/* ═══ OS ÍCONES SE DESENHAM AO ENTRAR NA TELA — [2026-08-21] ═══════════════
   Pedido dele: ícones animados, com a referência `joyco/image-sequence` —
   um player que materializa o objeto, de wireframe para renderizado.

   🔑 NÃO É SEQUÊNCIA DE QUADROS, E A TROCA É DELIBERADA. Aquele componente
     carrega dezenas de PNGs por objeto; aqui seriam quatro ícones × ~40
     quadros num site cujo gargalo medido é peso no celular. O mesmo GESTO —
     o objeto se materializando — sai de graça em SVG: o traço se desenha.
     E fica mais fiel à marca do que a referência, porque a peça da Éttore
     nasce exatamente assim, traço por traço, camada por camada.

   🪤 `pathLength="1"` EM TODO TRAÇO. Sem isso, cada `path` teria o próprio
     comprimento real e o `dashoffset` precisaria ser calculado um a um em JS.
     Normalizado em 1, o mesmo CSS serve para qualquer desenho.
   ⚠️ `stroke-dashoffset` e `opacity` NÃO são propriedades de layout — animar
     não recalcula a página. É a regra dura do projeto sobre animação.
*/
(function () {
  'use strict';
  if (window.__ettoreIlustra) return;
  window.__ettoreIlustra = 1;

  var calmo = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function liga() {
    var todos = document.querySelectorAll('[data-ilus]');
    if (!todos.length) return;

    /* ⚠️ QUEM PEDIU MENOS MOVIMENTO VÊ O ÍCONE PRONTO, não vê ícone nenhum
       pela metade. A classe entra na hora, sem observador. */
    if (calmo || !('IntersectionObserver' in window)) {
      todos.forEach(function (s) { s.classList.add('pronto'); });
      return;
    }

    var olho = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('desenha');
        olho.unobserve(en.target);   /* uma vez só: redesenhar a cada rolagem irrita */
      });
    }, { threshold: 0.4, rootMargin: '0px 0px -8% 0px' });

    todos.forEach(function (s) { olho.observe(s); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', liga);
  } else {
    liga();
  }
})();
